import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import {
  button as defaultStyle,
  primary as primaryStyle,
  small as smallStyle,
  secondary as secondaryStyle,
} from './styles.module.css';

/**
 * Generic button presentational component.
 */
const Button = ({
  children,
  className,
  disabled,
  primary,
  secondary,
  small,
  ...props
}) => {
  return (
    <button
      type="button"
      className={classnames({
        [primaryStyle]: !!primary,
        [secondaryStyle]: !!secondary,
        [smallStyle]: !!small,
        [defaultStyle]: !primary && !secondary,
        [className]: !!className,
      })}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  /**
   * Children contents of button.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean to disabled button.
   */
  disabled: PropTypes.bool,
  /**
   * Boolean to style button as primary.
   */
  primary: PropTypes.bool,
};

Button.defaultProps = {
  className: undefined,
  disabled: false,
  primary: false,
};

export default Button;
